export default {
  questionAnswers: [],
  questionAnswerLoading: false,
}
